import React, { useRef } from 'react';
import '../../../registerSyncfusion';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useSelector } from 'react-redux';
import './MyTooltipComponent.css';
import useClickOutside from '../../../hooks/useClickOutside';

const MyTooltipComponent = ({ children, Content, className, targetClass, offsetX, offsetY, style, modeOpen, hidden }) => {

        const { lang } = useSelector(state => state.translate);
        const tooltipInstanceRef = useRef();
        const tooltipTargetRef = useRef();

        useClickOutside(tooltipTargetRef, () => {
                if (tooltipInstanceRef.current) {
                        tooltipInstanceRef.current.close();
                }
        });

        const beforeRenderHandler = () => {
                tooltipInstanceRef.current.content = Content
                tooltipInstanceRef.current.dataBind();
        };

        return (
                <div ref={tooltipTargetRef}>
                        <TooltipComponent
                                offsetX={offsetX}
                                offsetY={offsetY}
                                position='BottomCenter'
                                cssClass={`TooltipComponent ${className} ${`MyLang_${lang}`} ${hidden ? 'Hidden' : null}`}
                                showTipPointer={false}
                                style={style}
                                ref={tooltipInstanceRef}
                                beforeRender={beforeRenderHandler}
                                opensOn={modeOpen ? `Focus ${modeOpen}` : 'Auto'}
                        >
                                <div className={`target ${targetClass}`}>
                                        {children}
                                </div>
                        </TooltipComponent>
                </div>
        )
}
export default MyTooltipComponent;